import {PurchaseButtonIcon} from  './icons/PurchaseButton'
import {STRIPE_CHECKOUT_PATH} from '../utils/main-links'

type props = {
    productValue: string
    isSelf: boolean
    isWingman?: boolean
}

const PurchaseButton :  React.FC<props> = (props) => {
    const isSelfValue = props.isSelf ? 'true' : 'false'
    return (
        <>
        <form 
            action={STRIPE_CHECKOUT_PATH}
            method="POST" 
            id={"handcart-" + props.productValue + isSelfValue}
        >
            {/* This is to send the products array with the id inside */}
            <input 
                type="hidden" 
                name="products[]" 
                value={props.productValue} 
            />

            {/* This is to set the isSelf - This case would be 1 = true */}
            <input 
                type="hidden" 
                name="isSelf" 
                value={isSelfValue} 
            /> 

        </form>
        <button 
            type="submit" 
            form={"handcart-" + props.productValue + isSelfValue}
            value="Submit" 
            className={props.isSelf ? 'modal-button-sign-in' : 'modal-button-purchase'} 
            disabled={false}
        >
            {
                props.isWingman 
                ? 'Purchase Now' 
                : 
                <>
                    {props.isSelf ? null : <PurchaseButtonIcon/>} {props.isSelf}
                    {props.isSelf ? 'Purchase For Myself' : 'Purchase as Gift'}
                </>
            }

        </button>
        </>
    )
}

PurchaseButton.defaultProps = {
    isWingman: false,
};

export default PurchaseButton

